import * as React from 'react';
import { observer } from 'mobx-react';

import useStores from '../../../../hooks/useStores';

import Button from '../../../../components/@common/Button';

import Card from '../../../../components/Card';

import * as S from './styles';

function PaymentConfirm({ focusCardData, onClickCancelButton }) {
  const { CardWallet, AppHandler } = useStores();

  const onClickPaymentButton = () => {
    AppHandler.handlePayment(focusCardData.id);
  };

  return (
    <>
      <h2>결제 확인</h2>
      {focusCardData && <Card {...focusCardData} />}
      <S.PaymentInfo>
        <S.PaymentLabel>가격</S.PaymentLabel>
        <S.PaymentPrice>{CardWallet.amountPaid.toLocaleString()}</S.PaymentPrice>
      </S.PaymentInfo>

      <div className="button-container flex">
        <Button type="primary" width="50%" onClick={onClickPaymentButton}>
          결제
        </Button>
        <Button type="warning" width="50%" onClick={onClickCancelButton}>
          결제 취소
        </Button>
      </div>
    </>
  );
}

export default observer(PaymentConfirm);
